import React, {
    Component
} from 'react';
import * as Config from '../../config/Config';
import ImageAudioTile from './ImageAudioTile';
import RecordPlayer from './RecordPlayer';
import * as Common from '../../helpers/Common';
import * as User from '../../helpers/User';
const $ = window.$;



export default class GridTile extends Component {

    constructor(props) {
        super(props);
        this.state = {
            subMitButton: "hide"
        };
    }

    // show grid responsively using range field (#gridresponserange)
    gridresponserange_fn = (e, divorder) => {
        const restype = e.target.value //1,2,3,4,5
        //let applyrespclass = 'minor-img ' + ((restype === '1') ? 'five-row' : ((restype === '2') ? 'four-row' : ((restype === '3') ? 'three-row' : ((restype === '4') ? 'two-row' : 'one-row'))))
        //changed as 5 to 3 point
        // /alert(restype);
        let applyrespclass = 'minor-img ' + ((restype === '1') ? 'five-row' : ((restype === '2') ? 'three-row' : 'one-row'))
        $('#maindiv' + divorder + ' #grid_tile').attr('class', applyrespclass)

    }




    change_comp(id, comptype, grid_id, gridType) {

        const { data, compData } = this.props;

        $.each($('audio'), function (i, audio) {
            audio.pause();
            audio.currentTime = 0;
        });

        Common.reactLoader("show", "Please wait...");

        let request_data = {
            comp_id: compData.id,
            learner_id: User.UserId(),
            compseq_id: compData.compseq_id,
            lroom_id: compData.learning_room_id,
            divider_id: compData.divider_id,
            dlrid: compData.dlr_id,
            comptype: comptype,
            grid_id: grid_id
        };

        fetch(Config.domainUrl + "girdcomponent/next-component", {
            method: "POST",

            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Common.getTokenData()
            },
            body: JSON.stringify(request_data),
        }).then((response) => response.json()).then((responseJson) => {

            Common.reactLoader("hide");

            let total_panels = $('div[id^="maindiv"]').length;
            let self = this;
            if (total_panels > 0) {

                if ((total_panels - 1) == id) {
                    self.setState({ subMitButton: "show" });
                }

                if (total_panels == 1) {
                    self.setState({ subMitButton: "show" });

                    if ($("#" + this.id).find(".button-accept").length > 0) {

                        $("#" + this.id).find(".button-accept").show();
                    }

                }

                if (total_panels != id) {

                    $('div[id^="maindiv"]').each(function () {
                        $(this).hide();
                        if ($("#" + this.id).find(".click-button").length > 0) {

                            if ($("#" + this.id).find(".click-button").hasClass("pin_up")) {
                                $("#" + this.id).find(".click-button").show();
                            } else {
                                $("#" + this.id).find(".click-button").hide();
                            }
                        }

                        if ($("#" + this.id).find(".button-accept").length > 0) {

                            if ($("#" + this.id).find(".button-accept").hasClass("pin_up")) {
                                $("#" + this.id).find(".button-accept").show();
                            } else {
                                $("#" + this.id).find(".button-accept").hide();
                            }
                        }

                    });
                }

                $("div#maindiv" + id).show();
            }

        });
    }

    submit(comptype, grid_id, gridType) {

        const { data, compData } = this.props;

        let request_data = {
            comp_id: compData.id,
            learner_id: User.UserId(),
            compseq_id: compData.compseq_id,
            lroom_id: compData.learning_room_id,
            divider_id: compData.divider_id,
            dlrid: compData.dlr_id,
            comptype: comptype,
            grid_id: grid_id
        };
        Common.reactLoader("show", "Please wait...");

        fetch(Config.domainUrl + "girdcomponent/submit", {
            method: "POST",

            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + Common.getTokenData()
            },
            body: JSON.stringify(request_data),
        }).then((response) => response.json()).then((responseJson) => {
            Common.reactLoader("hide");
            if (responseJson.status == 2) {
                Common.scrollToTop();
                if (responseJson.isCompletedFully) {
                    this.props.goToThanksPage();
                } else {
                    Common.message('Good Job!', 'You have successfully finished this component.', 'success');
                    if (this.props.usableType == "webapp") {
                        this.props.switchbackList();
                    }
                }
            } else {
                // Common.message('','You already finished this component.','error');
                this.props.switchbackList();
            }
        });

    }

    componentDidMount() {
       $(document).mouseup(function (e) {
        if((!$('.detail-popup').is(e.target) && $('.detail-popup').has(e.target).length === 0) && (!$('.dots-popup').is(e.target) && $('.dots-popup').has(e.target).length === 0))
        {
            $('.detail-popup').slideUp('slow');
        }
       
        
        });



        setTimeout(() => {
            let total_panels = $('div[id^="maindiv"]').length;

            if (total_panels == 1) {
                this.setState({ subMitButton: "show" });
            }
        }, 900);

        //click left menu grid change to full view
        $(document).on('click', '#leftmenuarrow', function () {
            $('#gridresponserange').val('1')
            $('#grid_tile').attr('class', 'minor-img five-row')

        })

        //audio player option div (slow/normal)
        /* $(document).on('click', '.dotsof', function () {
             console.log($(this));
             $(this).next('.detail-popup').slideToggle('slow');
            
             
         })
         
         
        */
    //    $(window).click(function(event) {

    //        console.log($(event.target).closest(".dots").length);
    //            if($(event.target).closest(".dots").length == 0)
    //            {
    //             alert("dd");   
    //            }
    //        });
   
    

    }

    render() {
        const { data, compData, learningCompletedStatus } = this.props;
        //const grmin = ($(window).width() <= 500) ? 4 : (($(window).width() <= 550) ? 3 : (($(window).width() <= 960) ? 2 : 1));
        let grmin = '';
        if($(window).width() == 320)
        {
            grmin=2;
        }
        else if($(window).width() < 500)
        {
            grmin=2;
        }
        else if($(window).width() == 500)
        {
            grmin=2;
        }
        else if($(window).width() <= 960)
        {
            grmin=2;
        }
        else
        {
            grmin=1;
        }
        
        return (
            <div className="grd-tails">

                {data.length > 0 &&
                    <div>
                        {data.map((key, ind) =>

                            <div key={ind} id={`maindiv${ind}`} style={{ display: (ind == 0) ? 'block' : 'none' }}>

                                {key.type == 'grid' &&
                                    <div>
                                        <div className="title-head">
                                            <h1>{key.gridData.major_desc}</h1>
                                            <div className="slidecontainer">
                                                {/* <input type="range" min={grmin} max="5" defaultValue={((key.class === 'five-row') ? '1' : ((key.class === 'four-row') ? '2' : ((key.class === 'three-row') ? '3' : ((key.class === 'two-row') ? '4' : '5'))))} className="slider" id="gridresponserange" onChange={(e) => this.gridresponserange_fn(e,`${ind}`)} /> */}
                                                <input type="range" min={grmin} max="3" defaultValue={'1'} className="slider" id="gridresponserange" onChange={(e) => this.gridresponserange_fn(e, `${ind}`)} />
                                            </div>
                                        </div>
                                        <div className="grid-box">{key.gridData.minor_desc}</div>
                                        <div className="grid-img gridTile">
                                            {/* <div className={`minor-img ${key.class}`} id="grid_tile"> */}
                                            <div className={`minor-img ${'five-row'}`} id="grid_tile">
                                                <ul className={(5>key.tiles.length)? 'ajus_min_5tile': ''}>
                                                    {key.tiles.map((val, i) =>
                                                        <li key={`Li_${i}`} id={`image${val.data.tile_id_pk}_${ind}`}>
                                                            <ImageAudioTile key={`ImageAudioTile_${i}`} index={ind} data={key} tileData={val} compData={compData} learningCompletedStatus={learningCompletedStatus} />

                                                        </li>
                                                    )}
                                                </ul>
                                            </div>
                                        </div>
                                        {key.gridType == "Voice Practice" &&
                                            <RecordPlayer key={`record${ind}`} />
                                        }

                                        <div style={{ width: "100%", textAlign: "center", marginTop: "30px", float: 'left' }}>
                                            {(this.state.subMitButton == "show") ? <input type="button" value="Next" alt="Go to next page" className="button-accept custom-button-adj" onClick={(e) => this.submit(key.type, key.gridData.grid_id_pk, key.gridType)} style={{ display: 'none' }} /> :
                                                <a style={{ display: (ind == 0 && key.type == 'pin_up') ? '' : 'none' }} href="javascript:void(0)" className="click-button" onClick={(e) => this.change_comp((ind + 1), key.type, key.gridData.grid_id_pk, key.gridType)}>next</a>
                                            }
                                        </div>

                                    </div>
                                }



                                {key.type == 'pin_up' &&
                                    <div className="project-content">
                                        {key.comp_obj != null &&
                                            <div>
                                                <div className="msg-bgs">
                                                    <div className="btm-bg">
                                                        <div className="project-content-inner">
                                                            <h1>{key.comp_obj.msg_title}</h1>
                                                            <div className="align-cus">
                                                                <span>{key.comp_obj.msg_textarea}</span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div style={{ width: "100%", textAlign: "center", float: 'left' }}>
                                                    {(this.state.subMitButton == "show") ? <input type="button" value="Next" alt="Go to next page" className={(key.type == 'pin_up') ? 'button-accept custom-button-adj pin_up' : 'button-accept custom-button-adj'} onClick={(e) => this.submit(key.type, key.comp_obj.msg_id_pk, key.gridType)} style={{ display: 'none' }} /> :
                                                        <a style={{ display: (key.type == 'pin_up') ? '' : 'none' }} href="javascript:void(0)" className={(key.type == 'pin_up') ? 'click-button pin_up' : 'click-button'} onClick={(e) => this.change_comp((ind + 1), key.type, key.comp_obj.msg_id_pk, key.gridType)}>next</a>
                                                    }
                                                </div>

                                            </div>
                                        }
                                    </div>
                                }





                            </div>
                        )}

                    </div>
                }
            </div>
        );
    }

}




// WEBPACK FOOTER //
// ./src/lr_dlr_components/grid_partials/GridTile.js